<template><div><h1 id="filter-verknupfen" tabindex="-1"><a class="header-anchor" href="#filter-verknupfen"><span>Filter verknüpfen</span></a></h1>
<p>Filter verknüpfen — Verknüpft Filter mit Ereignis/Merkmal/Publikationen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Die Filterverknüpfungen dienen der automatisierten Erfassung von Ereignis-, Merkmal-, oder Publikationsverknüpfungen mit einzelnen Personen. Jede Person, die im Filter enthalten ist, erhält die in diesem Programm definierte Verknüpfung.</p>
<p>Über Filterverknüpfungen können auch bestehende, allenfalls versehentlich erfasste Verknüpfungen wieder gelöscht werden. Das Programm sollte nur von geübten Benutzern verwendet werden, da damit wichtige Daten (Initialereignisse der Kundenhistory, Merkmale, Publikationen) im System verändert werden können.</p>
<p>Pfad: <code v-pre>Personen → Filter</code></p>
<h2 id="datenfelder-im-anzeige-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-im-anzeige-modus"><span>Datenfelder im Anzeige-Modus</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Filterbezeichnung</dd>
<dt>Jobdatum</dt>
<dd>Datum der Erfassung der Filterverknüpfung</dd>
<dt>Nr.</dt>
<dd>Laufnummer des Jobs (relevant wenn am gleichen Tag mehrere Verknüpfungen erfasst wurden)</dd>
<dt>Verknüpfungstyp</dt>
<dd>Zeigt an, was für eine Verknüpfung definiert wurde. Z.B. Merkmal erfassen, Ereignis löschen, etc.</dd>
<dt>Verknüpfung</dt>
<dd>Bezeichnung der Verknüpfung, z.B. kann das ein Merkmal sein (bei Merkmalsverknüpfung) oder ein Ereignis (bei Ereignisverknüpfung) sein, etc.</dd>
<dt>Status</dt>
<dd>Status der Verknüpfung. Z.B. erfasst, verknüpft, etc.</dd>
<dt>Status, Job-ID, Ausgabe (sep. Frame darunter)</dt>
<dd>In diesem Frame wird das Protokoll der Filterverknüpfung angezeigt und kann direkt hier geöffnet werden.</dd>
</dl>
<h2 id="datenfelder-im-erfassungs-modus" tabindex="-1"><a class="header-anchor" href="#datenfelder-im-erfassungs-modus"><span>Datenfelder im Erfassungs-Modus</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Filterbezeichnung</dd>
<dt>Verknüpfungstyp</dt>
<dd>Auswahl des Verknüpfungstyp. Z.B. Merkmal erfassen, Ereignis löschen, etc. Je nach Verknüpfungstyp werden die entsprechenden Felder angezeigt. Z.B. bei Merkmalverknüpfung Merkmalsfelder, bei Ereignisverknüpfung Ereignisfelder, etc.</dd>
<dt>Job erfassen</dt>
<dd>Bei dieser Option wird der Job erfasst, aber die Verknüpfung wird noch nicht vorgenommen.</dd>
<dt>Job erfassen und Filter verknüpfen</dt>
<dd>Bei dieser Option wird der Job erfasst und zugleich auch die Filterverknüpfungen vorgenommen.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<h3 id="filter-verknupfen-1" tabindex="-1"><a class="header-anchor" href="#filter-verknupfen-1"><span>Filter verknüpfen</span></a></h3>
<p>Verknüpft Filter mit Ereignis/Merkmal/Publikationen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


